import script from "./order-item-inventory-combobox.vue?vue&type=script&setup=true&lang=js"
export * from "./order-item-inventory-combobox.vue?vue&type=script&setup=true&lang=js"

import "./order-item-inventory-combobox.vue?vue&type=style&index=0&id=ed6b63a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed6b63a6"]])

export default __exports__